import React from 'react';
import mergeOptions from 'merge-options';
import dlv from 'dlv';
import withStyles from '@material-ui/core/styles/withStyles';
import { isString, safeStringify, safeParse, cleanUrl } from '../../util';
import TMPL_STR_REPLACE_MAP from './tmpl-str-replace-map';

const applySkins = (skins, useSkin, overrides) => {
    if (isString(useSkin)) {
        return mergeOptions(dlv(skins, useSkin, {}), overrides);
    } else if (Array.isArray(useSkin)) {
        return mergeOptions(
            useSkin.reduce((acc, uSkin) => {
                acc = mergeOptions(acc, dlv(skins, uSkin, {}));
                return acc;
            }, {}),
            overrides
        )
    } else {
        return overrides;
    }
}

const replaceTmplStr = jss => {
    let jssString = safeStringify(jss);

    if (!jssString) return jss;

    Object.keys(TMPL_STR_REPLACE_MAP).forEach(k => {
        jssString = cleanUrl(jssString.replace(k, TMPL_STR_REPLACE_MAP[k]));
    });

    return safeParse(jssString);
}

const ApplySkinOverride = React.memo(
    ({ style }) => {
        const Component = withStyles(
            ({ customStyles: { skins = {}, styles = {} } = {} }) => {
                const { '@skin': useSkin, ...overrides } = dlv(styles, style, {});
                const jss = useSkin ? applySkins(skins, useSkin, overrides) : overrides;

                return { '@global': replaceTmplStr(jss) };
            }
        )(() => null);

        return <Component />
    }
);

export default ApplySkinOverride;